<template lang="pug">
  .component-tabbed-vehicle-instructions
    ActionBar
      h2(slot="title") Vehicle Instructions
      .fa.fa-plus(slot="action", @click="add = !add")
    .instruction-list(v-show="add")
      .row
        .columns
          selectize-instructions(@optionSelected="selectInstruction")
        .columns
          button.button(@click="addInstruction", v-if="!addInProgress") Add
      loading-spinner(v-if="addInProgress")
    .container
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false", ref="baseList", component-type="entityList")


</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from '../../../pages/backoffice/BaseList'
  import HeaderColumns from '../../structure/ui/HeaderColumns'
  import ModalReveal from '../../structure/foundation/ModalReveal'
  import CreateNote from '../../../pages/backoffice/CreateNote'
  import CreateNoteModal from '../../../pages/backoffice/CreateNoteModal'
  import ActionBar from '../../structure/ui/ActionBar'
  import SelectizeInstructions from '../../structure/ui/lists/selectize/SelectizeInstructions'
  import LoadingAnimation from '../../lib/LoadingAnimation'
  import LoadingSpinner from '../../structure/LoadingSpinner'
  import MaggieHelper from '../../../maggieHelper'

  export default {
    name: 'TabbedVehicleInstructions',
    components: {
      LoadingSpinner,
      LoadingAnimation,
      SelectizeInstructions,
      ActionBar,
      CreateNoteModal,
      CreateNote,
      ModalReveal,
      HeaderColumns,
      BaseList,
    },
    data() {
      return {
        add: false,
        addInProgress: false,
        instruction_id: null,
        component: require('src/components/backoffice/Instruction'),
      }
    },
    created() {

    },
    methods: {
      addNote() {
        this.$refs.baseList.loadData(1)
      },
      dataLoader(callback) {
        var instructions = {
          current_page: 1,
          current_page_count: 1,
          items: [],
          items_count: 0,
          page_count: 1,
          per_page_count: 25,
        }

        KeplerBackofficeSdk.vehicleInstructions.list.all((data) => {
          instructions.items = data.filter((item) => {
            return item.vehicle.id === parseInt(this.$route.params.id)
          })
          instructions.items_count = instructions.items.length
          callback(instructions)
        })
      },
      selectInstruction(obj) {
        this.instruction_id = obj.id
      },
      addInstruction() {
        this.addInProgress = true
        KeplerBackofficeSdk.vehicleInstructions.make({
          instruction_id: this.instruction_id,
          vehicle_id: this.$route.params.id
        }, () => {
          this.$refs.baseList.loadData(1)
          this.addInProgress = false
          this.add = false
          this.instruction_id = null
          MaggieHelper.notification('Done', 'Instruction added')
        })
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-instructions
    width: 100%
    background: white
    padding-bottom: 25px
    .container
      margin: 20px
    .instruction-list
      padding: 20px
</style>



// WEBPACK FOOTER //
// VehicleInstructions.vue?12955575